if(!import.meta.env.PROD) {
	import ('../scss/style-critical.scss');
}
import '../scss/style.scss';

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

const modules = document.querySelectorAll('.module, .header, .partial');
modules.forEach(function (module) {
	const moduleClass = module.classList[1] || module.classList[0];
	const isPartial = module.classList.contains('partial');
	const pathPrefix = isPartial ? 'partials' : 'modules';
	import(`./${pathPrefix}/${moduleClass}.js`).then(({ default: Module }) => {
		new Module($(module));
	}).catch(() => {
		if(!import.meta.env.PROD) {
			//console.warn(`Module script "${moduleClass}" not found. Ignore this error if the module script is not needed. \n Additional info:`, err);
		}
	});
});
